import { render, staticRenderFns } from "./manageType.vue?vue&type=template&id=d941d08e&scoped=true"
import script from "./manageType.vue?vue&type=script&lang=js"
export * from "./manageType.vue?vue&type=script&lang=js"
import style0 from "./manageType.vue?vue&type=style&index=0&id=d941d08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d941d08e",
  null
  
)

export default component.exports